<div class="compliance-wrapper">
	<div class="compliance-outer">
		<h2 class="compliance-header text-center mb-4">
			The RegScale Difference
		</h2>
		<p class="ready-set-content text-center mb-5">
			Most solutions are like M&Ms, hard on the outside (i.e., behind a
			firewall), but soft <br class="d-none d-md-block" />
			in the center (easy to move inside the network). RegScale is a
			peanut M&M that <br class="d-none d-md-block" />
			is hardened throughout using the latest Zero-Trust security
			techniques.
		</p>
	</div>
	<div class="compliance-container">
		<div class="compliance-container-inner">
			<img
				class="d-none d-md-block orange-pattern-overlay"
				src="../../assets/img/orange-pattern.png"
				alt=""
			/>
			<img
				class="d-md-none orange-pattern-overlay"
				src="../../assets/img/orange-pattern-mobile.png"
				alt=""
			/>
			<div class="container text-center">
				<div class="row">
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/persistent-reconstruction.svg"
							alt=""
						/>
						<div class="challenges-list-head">
							Persistent Reconstruction
						</div>
						<div class="challenges-list-content">
							Say goodbye to patching. We rebuild
							<br class="d-none d-xl-block" />
							new every time, eliminating any zero-
							<br class="d-none d-xl-block" />day threats while
							rotating certificates
							<br class="d-none d-xl-block" />
							automatically, forcing adversaries to try
							<br class="d-none d-xl-block" />
							and hit a moving target.
						</div>
					</div>
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/uninterrupted-surveillance.svg"
							alt=""
						/>
						<div class="challenges-list-head">
							Uninterrupted Surveillance
						</div>
						<div class="challenges-list-content">
							Offload all your logs to your Security and
							<br class="d-none d-xl-block" />
							Information Event Management (SIEM) tools
							<br class="d-none d-xl-block" />
							for real-time monitoring with Splunk,
							<br class="d-none d-xl-block" />
							ElasticSearch, or other cloud 
							<br class="d-none d-xl-block" />
							technologies.
						</div>
					</div>
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/defense-in-depth.svg"
							alt=""
						/>
						<div class="challenges-list-head">Defense-In-Depth</div>
						<div class="challenges-list-content">
							We deny all traffic by default, minimize open
							<br class="d-none d-xl-block" />
							ports, and make it extremely difficult to move
							<br class="d-none d-xl-block" />
							laterally by micro-segmenting application
							<br class="d-none d-xl-block" />
							services using Kubernetes' Software Defined
							<br class="d-none d-xl-block" />
							Network (SDN).
						</div>
					</div>
				</div>
				<a [routerLink]="['/pricing']">
					<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
						Get Started for Free
					</button></a
				>
			</div>
		</div>
	</div>
</div>
